export default __webpack_public_path__ + "static/media/i am.9346df78.jpg";